module.exports = __webpack_public_path__ + "static/media/showPdfImage.8cfa7225.svg";